module.exports = __webpack_public_path__ + "img/rank_11.b8ff2df.png";